module.exports = __webpack_public_path__ + "img/choose-up-Up Cadou-disabled.e8825ae4.png";